export const MAX_CLIP_SIZE_BYTES = 150 * 1024 * 1024;
export const MAX_BULK_FILES = 10;

export function validateClipFile(file: File): string | null {
  if (!file.type.startsWith("video/")) {
    return `${file.name} is not a video file.`;
  }
  if (file.size > MAX_CLIP_SIZE_BYTES) {
    return `${file.name} is larger than the 150 MB limit.`;
  }
  if (file.size === 0) {
    return `${file.name} is empty.`;
  }
  return null;
}
